import { render, staticRenderFns } from "./adminManage.vue?vue&type=template&id=5b9a8968&scoped=true"
import script from "./adminManage.vue?vue&type=script&lang=js"
export * from "./adminManage.vue?vue&type=script&lang=js"
import style0 from "./adminManage.vue?vue&type=style&index=0&id=5b9a8968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a8968",
  null
  
)

export default component.exports